import * as d3 from 'd3'

import { Chart } from '../chart'

/**
 * Class which represents a PieChart model used in the PieChart vue component
 */
export class RotationChart extends Chart {
  constructor(chartId, dataset, chartType, width, height, margin, $t) {
    super(chartId, dataset, chartType, width, height, margin, $t)
    this.radius = 200
    this.gridSize = Math.floor(width / 24)
  }

  /**
   * Draw a pie chart
   */
  draw() {
    let that = this

    d3.select('#' + this.chartId + ' svg').remove()

    this.svgHeight =
      (this.gridSize / 22) * this.dataset.items.length +
      this.margin.top * 2 +
      this.margin.bottom * 3

    this.svg = d3
      .select('#' + this.chartId)
      .append('svg')
      .attr('width', '100%')
      .attr('id', 'svg-' + this.chartId)
      .attr('viewBox', '0 0 ' + this.svgWidth + ' ' + this.svgHeight)
      .attr('preserveAspectRatio', 'xMaxYMin')
      .append('g')
      .attr('transform', 'translate(' + this.margin.left + ',' + this.margin.top * 2 + ')')

    //Display cards for each used device over period
    var cards = this.svg.selectAll('.device').data(this.dataset.items, function(d) {
      return d.category + ' : ' + d.count + ' (' + d.rotation + ' ' + that.$t('unit.d') + ')'
    })

    cards
      .enter()
      .append('rect')
      .attr('x', function(d, i) {
        return (i % 22) * that.gridSize
      })
      .attr('y', function(d, i) {
        return Math.floor(i / 22) * that.gridSize
      })
      .attr('rx', 4)
      .attr('ry', 4)
      .attr('class', 'hour bordered')
      .attr('width', this.gridSize)
      .attr('height', this.gridSize)
      .attr('fill', function(d) {
        return d.rotation < that.colors.length
          ? that.colors[d.rotation]
          : that.colors[that.colors.length - 1]
      })
      .on('mouseover', this.tooltip.show)
      .on('mouseout', this.tooltip.hide)

    //Legend
    var legend = this.svg
      .selectAll('.legend')
      .data(this.colors)
      .enter()
      .append('g')
      .attr('class', 'legend')
      .attr('transform', function(d, i) {
        return 'translate(0,' + i * 20 + ')'
      })

    legend
      .append('rect')
      .attr('x', that.width - 10)
      .attr('width', 18)
      .attr('height', 18)
      .style('fill', function(d, i) {
        return i > that.colors.length ? that.colors[that.colors.length - 1] : that.colors[i]
      })

    legend
      .append('text')
      .attr('x', that.width - 18)
      .attr('y', 9)
      .attr('dy', '.35em')
      .style('text-anchor', 'end')
      .text(function(d, i) {
        return i
      })

    this.svg
      .append('text')
      .attr('class', 'repartition-title title-font')
      .attr('x', 0)
      .attr('y', this.svgHeight - this.margin.bottom * 2.5)
      .attr('text-anchor', 'left')
      .html(
        this.dataset.items.length > 1
          ? `${this.$t('on')} ${this.dataset.items.length} ${this.$t('used_tablets')} :`
          : `${this.$t('on')} ${this.dataset.items.length} ${this.$t('used_tablet')} :`,
      )

    this.svg
      .append('text')
      .attr('class', 'repartition-title')
      .attr('x', 0)
      .attr('y', this.svgHeight - this.margin.bottom * 1.5)
      .attr('text-anchor', 'left')
      .html(this.getDistributionText())

    this.svg
      .append('text')
      .attr('class', 'repartition-title')
      .attr('x', this.width / 2)
      .attr('y', 0 - this.margin.top)
      .attr('text-anchor', 'middle')
      .text(this.title)
  }

  /**
   * Get legend text for distribution
   */
  getDistributionText() {
    var text = ''
    this.dataset.distribution.forEach((r, index, arr) => {
      text +=
        r.rotations > 1
          ? `${r.percent} % (${r.count}) ${this.$t('for')} ${r.rotations} rotations`
          : `${r.percent} % (${r.count}) ${this.$t('for')} ${r.rotations} rotation`
      if (index < arr.length - 1) {
        text += ', '
      }
    })
    return text
  }

  /**
   *
   * @param {} otherCategories
   */
  initTooltip(otherCategories) {
    super.initTooltip(otherCategories)
  }
}
